import Guest from '@/layouts/guest';
import React, { useEffect } from 'react';
import {Container} from "react-bootstrap";
import TermsContent from "@/components/terms/content";
import { setCanonical } from '@/app/general';

const Terms: React.FC = () => {

  const html = `<ul><li><p class="mb-2">تکست نویس بر اساس قوانین جمهوری اسلامی مدیریت می شود.</p></li><li>استفاده از الفاظ رکیک - نژادپرستی - توهین به افراد سیاسی و بالا مرتبه کشور ممنوع است. (درصورت مشاهده کاربر به پلیس فتا ارجاع خواهد شد)</li><li>فروش یک تکست - بیت - ماکت به چند نفر ممنوع می باشد. در صورت مشاهده کاربر مسدود و هیچگونه مبلغی عودت داده نخواهد شد.</li><li>در صورت استفاده از تکست یا بیت دانلودی باید در توضیحات ذکر شود. در صورت عدم رعایت کاربر موظف است مبلغ را به خریدار عودت کند و در غیر اینصورت به عنوان کلاهبردار به پلیس فتا معرفی خواهد گردید.</li><li>آهنگساز و شاعر حق فروش کار آپلود شده در تکست نویس را در سایت ها و اپلیکیشن های دیگر ندارد. درصورت مشاهده کاربر مسدود خواهد شد.</li><li>کاربر موظف است فقط و فقط ساخته های خودش را به فروش بگذارد و از هنرهای دیگران استفاده نکند.</li><li>درصورت درخواست خریدار بنا به تغییرات جزیی (تا ۳۰ درصد از کار) شاعر یا آهنگساز موظف است بصورت رایگان آنرا ویرایش کند.</li><li>تغییرات بیشتر از ۳۰ درصد کار بصورت توافقی انجام خواهد شد.</li><li>هر کاربر موظف است ماهیانه یک کار رایگان آپلود کند.</li><li>کارهای فروخته شده به هیچ عنوان پس گرفته نمی شود.</li><li>سهم تکست نویس از از فروش هر قطعه ۲۰ درصد مبلغ کل می باشد.</li></ul>`;

  useEffect(() => {
    setCanonical();
  }, []);

  return (
    <Guest title="قوانین و مقررات">
      <Container className="py-5">
        <TermsContent html={html} />
      </Container>
    </Guest>
  );
}

export default Terms;
